"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _coreMatchMedia = require("@vfuk/core-match-media");

var sortedBreakpoints = ['xl', 'lg', 'md', 'sm'];

function useBreakpointSwitch(data) {
  var breakpoints = (0, _coreMatchMedia.useBreakpoints)();
  if (typeof data[breakpoints.current] !== 'undefined') return data[breakpoints.current];
  var validBreakpoints = sortedBreakpoints.filter(function (breakpoint) {
    return Object.prototype.hasOwnProperty.call(data, breakpoint) || sortedBreakpoints.indexOf(breakpoint) < sortedBreakpoints.indexOf(breakpoints.current);
  });
  return validBreakpoints.reduce(function (acc, breakpoint, i) {
    if (breakpoints[breakpoint] && (i === 0 || !breakpoints[sortedBreakpoints[i - 1]])) {
      return data[breakpoint];
    }

    return acc;
  }, undefined);
}

var _default = useBreakpointSwitch;
exports["default"] = _default;
//# sourceMappingURL=useBreakpointSwitch.js.map